var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"cursor-pointer",attrs:{"src":"https://d3r2ol85dktaw0.cloudfront.net/conferences/gbcc2022/event_img/korea-tourism-event.jpg"},on:{"click":_vm.goToKoreanTour}})])}
var staticRenderFns = []

export { render, staticRenderFns }